module.exports = __webpack_public_path__ + "img/salad.826a9095.png";